import { useCallback } from "react"

const REVIEW_APP_PATTERN = /^verdikt-pr-\d+\.herokuapp\.com$/
export const REVIEW_HOSTS = ["review_apps"]

const DEV_HOSTS = ["localhost", "verdikt-web-dev.herokuapp.com"]
const TEST_HOSTS = ["verdikt-web-test.herokuapp.com"]
const DEMO_HOSTS = ["verdikt-web-demo.herokuapp.com"]
const PREPROD_HOSTS = ["verdikt-web-preprod.herokuapp.com"]
const PROD_HOSTS = ["verdikt-web-production.herokuapp.com", "app.verdikt.io"]
const PREPROD_PROD_HOSTS = PROD_HOSTS + PREPROD_HOSTS + REVIEW_HOSTS
const ALL_HOSTS =
  DEV_HOSTS +
  TEST_HOSTS +
  DEMO_HOSTS +
  PREPROD_HOSTS +
  PROD_HOSTS +
  REVIEW_HOSTS

export const PROFIT_PILLAR_FEATURE = "profit"
export const SIMULATE_FEATURE = "simulation"
export const GHG_RECOMMENDATION_FEATURE = "ghgRecommendation"
export const OFFICE_365_FEATURE = "office365"
export const REPLAY_ALWAYS_VISIBLE = "replayAlwaysVisible"
export const FLEX_INVENTORY_FEATURE = "flexInventory"
export const HIDE_PROVIDER_MATURITY_FEATURE = "hideProviderMaturity"
export const SHOW_PROVIDER_MIGRATED_MATURITY_FEATURE =
  "showProviderMigratedMaturity"
export const PROFIT_RECOMMENDATION_FEATURE = "profitRecommendation"
export const FAKE_GHG_PROTOCOL_FEATURE = "fakeGhgProtocol"
export const FAKE_SIMULATION_FEATURE = "fakeSimulation"
export const COMPARE_WEBSITES_AND_ASSETS_FEATURE = "compareWebsitesAndAssets"
export const COMPARE_HIDE_MATURITY_CHARTS = "compareHideMaturityCharts"

export const REF_DB_FEATURE = "refDb"

export const USE_PRODUCTION_REF_DB_URL = "prodRefDBURL"

export const SHOW_LIMITED_REF_DB_SEARCH_BANNER = "showLimitedRefDBSearchBanner"

const FEATURES_TO_HOSTS = {
  [OFFICE_365_FEATURE]: ALL_HOSTS,
  [USE_PRODUCTION_REF_DB_URL]: PROD_HOSTS + REVIEW_HOSTS,
  [SHOW_LIMITED_REF_DB_SEARCH_BANNER]: DEMO_HOSTS,
  [COMPARE_HIDE_MATURITY_CHARTS]: DEMO_HOSTS,

  // Todo: what is that?
  [REPLAY_ALWAYS_VISIBLE]: DEV_HOSTS + DEMO_HOSTS,
  [FLEX_INVENTORY_FEATURE]: ALL_HOSTS,

  // Todo: do we still need that?
  [HIDE_PROVIDER_MATURITY_FEATURE]: ALL_HOSTS,
  [SHOW_PROVIDER_MIGRATED_MATURITY_FEATURE]: DEV_HOSTS,

  // Todo: finalize, decom and deploy
  [GHG_RECOMMENDATION_FEATURE]: DEV_HOSTS + TEST_HOSTS + DEMO_HOSTS,
  [FAKE_GHG_PROTOCOL_FEATURE]: DEMO_HOSTS,

  // Todo: decom
  [SIMULATE_FEATURE]: DEV_HOSTS,
  [FAKE_SIMULATION_FEATURE]: DEV_HOSTS + TEST_HOSTS,
  [COMPARE_WEBSITES_AND_ASSETS_FEATURE]: DEV_HOSTS + TEST_HOSTS,

  // todo: fix
  [PROFIT_RECOMMENDATION_FEATURE]: [...DEV_HOSTS, ...TEST_HOSTS, ...DEMO_HOSTS],

  // Todo: finalize and deploy
  [REF_DB_FEATURE]: DEV_HOSTS + TEST_HOSTS + DEMO_HOSTS,
}

export const useFeatureFlag = () => {
  const hostname = window.location.hostname

  const isFeatureActive = useCallback((feature) => {
    const hosts = FEATURES_TO_HOSTS[feature]
    if (!hosts) return false
    if (REVIEW_APP_PATTERN.test(hostname)) return hosts.includes(REVIEW_HOSTS)
    return hosts.includes(hostname)
  }, [])

  const ifFeatureActive = (feature, component, fallback = null) =>
    isFeatureActive(feature) ? component : fallback

  return { isFeatureActive, ifFeatureActive }
}
